import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { defaultPageRowOptions, defaultRowOptions, paginatorLinks, showingEntries, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { postAllData } from '../../../service/ProductService';
import { PROFITLOSS } from '../../../config/ApiConstant';
import { ExpenseReportListColumns, IncomeReportListColumns } from '../../../appconfig/DatatableSetting';
import moment from 'moment';
import { exportData } from '../../../appconfig/AppHelper';
import { amountCommonTemplate, amountTemplate } from '../../../appconfig/DatatableTemplateSetting';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const ProfitLossReport = () => {
    document.title = 'Profit And Loss Account | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [expenseList, setExpenseList] = useState<any>([]);
    const [incomeList, setIncomeList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);
    const [showButton, setShowButton] = useState<boolean>(false);

    // Date Object
    const storedDates = localStorage.getItem('profitloss_report');
    let initialStartDate = moment().subtract(1, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });
        if (start && end) {
            localStorage.setItem(
                'profitloss_report',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />

                <Button label="Show" onClick={() => getTrialBalanceReport()} loading={showLoading} className="ml-2"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader} disabled={showButton ? false : true}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('Profit_Loss_Report');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getTrialBalanceReportList
    const getTrialBalanceReport = async () => {
        try {
            setPageLoad(false);
            setShowLoading(true);

            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            // Request Data
            const requestData = {
                from_date: startDate,
                to_date: endDate
            };

            const response = await postAllData(PROFITLOSS, requestData);

            if (response) {
                setPageLoad(true);
                setShowLoading(false);
                setExpenseList(response?.expence);
                setIncomeList(response?.income);
                setShowButton(true);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoading(false);
                setShowButton(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Financial Reports'} pageName={'Profit & Loss Report'} pageTitle={'Profit & Loss Report'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2 pci-register">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        <div className="grid mt-2">
                            <div className="col-12 md:col-6">
                                <h6>Expense List</h6>
                                {pageLoad ? (
                                    <>
                                        <DataTable
                                            value={expenseList}
                                            showGridlines
                                            stripedRows
                                            globalFilter={globalFilter}
                                            filters={globalFieldFilter}
                                            onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                            
                                            className="datatable-responsive p-datatable-sm"
                                            emptyMessage="No Data Found"
                                            removableSort
                                        >
                                            {ExpenseReportListColumns.map((col: any, i: any) => {
                                                if (col.field === 'debit') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={amountCommonTemplate} />;
                                                } else {
                                                    return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                                }
                                            })}
                                        </DataTable>
                                    </>
                                ) : (
                                    <>
                                        {/* Skeleton Data table */}
                                        <DataTable value={Skeletonitems}>
                                            {ExpenseReportListColumns.map((col: any, i: any) => (
                                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                            ))}
                                        </DataTable>
                                    </>
                                )}
                            </div>

                            <div className="col-12 md:col-6">
                                <h6>Income List</h6>
                                {pageLoad ? (
                                    <>
                                        <DataTable
                                            value={incomeList}
                                            showGridlines
                                            stripedRows
                                            globalFilter={globalFilter}
                                            filters={globalFieldFilter}
                                            onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                           
                                            className="datatable-responsive p-datatable-sm"
                                            emptyMessage="No Data Found"
                                            removableSort
                                        >
                                            {IncomeReportListColumns.map((col: any, i: any) => {
                                                if (col.field === 'credit') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={amountCommonTemplate} />;
                                                } else {
                                                    return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                                }
                                            })}
                                        </DataTable>
                                    </>
                                ) : (
                                    <>
                                        {/* Skeleton Data table */}
                                        <DataTable value={Skeletonitems}>
                                            {IncomeReportListColumns.map((col: any, i: any) => (
                                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                            ))}
                                        </DataTable>
                                    </>
                                )}
                            </div>
                            <div className="col-12 md:col-12 mt-3">
                                <h5>Total Profit : {!window.cn(incomeList) && incomeList[0]?.credit - expenseList[0]?.debit > 0 ? Math.abs(incomeList[0]?.credit - expenseList[0]?.debit) + '.00' : '0.00'} </h5>
                                <h5>Total Loss : {!window.cn(incomeList) && incomeList[0]?.credit - expenseList[0]?.debit < 0 ? Math.abs(incomeList[0]?.credit - expenseList[0]?.debit) + '.00' : '0.00'} </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
